import { motion } from "framer-motion";
import { Clock } from "lucide-react";
import { Eyebrow } from "@/components/landing/Eyebrow";
import { SCROLL_REVEAL, WHY_2026 } from "@/lib/content";

export const Why2026 = () => {
  return (
    <section
      id="why-2026"
      data-testid="why-2026-section"
      className="relative bg-ink py-14 sm:py-20 overflow-hidden"
    >
      <div className="absolute top-0 left-0 right-0 hairline-h" aria-hidden />
      <div className="absolute inset-0 pointer-events-none spotlight-small" aria-hidden />

      <div className="relative container px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
        <div className="flex justify-center">
          <Eyebrow label="WHY 2026" sub="WINDOW" />
        </div>

        <motion.div {...SCROLL_REVEAL} className="mt-6 sm:mt-8">
          <p className="text-[11px] sm:text-xs text-[hsl(var(--muted-foreground))] uppercase tracking-[0.22em] mb-2">專家經濟黃金窗口</p>
          <h2 className="font-serif-tc text-[46px] leading-[1.05] sm:text-7xl lg:text-[96px] font-bold tracking-[-0.03em]">
            <span className="lime-keyword inline-flex items-center gap-2 sm:gap-3">
              <Clock className="w-8 h-8 sm:w-14 sm:h-14 lg:w-20 lg:h-20" />
              最後 18–24 個月
            </span>
          </h2>
          <p className="mt-5 sm:mt-7 text-[14px] sm:text-lg text-[hsl(var(--foreground))]/85 max-w-[58ch] mx-auto leading-relaxed">
            當頂尖專家全部上場，個人 IP 的壁壘會迅速形成。現在不建立護城河，未來只能以 10 倍成本追趕。
          </p>
        </motion.div>

        {/* 3 compact supporting points */}
        <motion.div {...SCROLL_REVEAL} className="mt-10 sm:mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 text-left">
          {WHY_2026.map((w, i) => (
            <div key={i} className="flex gap-3">
              <div className="stat-num text-[18px] text-[hsl(var(--lime))] flex-shrink-0 pt-0.5">0{i + 1}</div>
              <div>
                <div className="font-serif-tc text-[14px] sm:text-[15px] font-bold text-[hsl(var(--foreground))] leading-snug">
                  {w.title}
                </div>
                <p className="mt-1 text-[12px] sm:text-[13px] text-[hsl(var(--muted-foreground))] leading-relaxed">
                  {w.desc}
                </p>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
